module.exports = __webpack_public_path__ + "img/113ne.314d8feb.svg";